import { Observable } from 'rxjs';
import { Auth, onAuthStateChanged, User } from 'firebase/auth';
import { DocumentData, Query, onSnapshot } from 'firebase/firestore';

/**
 * Emits the currently signed in user, or `null` when signed out.
 * Replacement for the `authState` helper previously provided by `@angular/fire`.
 */
export function authState$(auth: Auth): Observable<User | null> {
  return new Observable<User | null>(subscriber =>
    onAuthStateChanged(
      auth,
      user => subscriber.next(user),
      error => subscriber.error(error)
    )
  );
}

export interface CollectionDataOptions {
  /** Name of the property the document id is written to. */
  idField?: string;
}

/**
 * Emits the documents of a collection/query on every snapshot.
 * Replacement for the `collectionData` helper previously provided by `@angular/fire`.
 */
export function collectionData$<T = DocumentData>(
  query: Query<DocumentData>,
  options: CollectionDataOptions = {}
): Observable<T[]> {
  const { idField } = options;

  return new Observable<T[]>(subscriber =>
    onSnapshot(
      query,
      snapshot =>
        subscriber.next(
          snapshot.docs.map(document =>
            idField ? { ...document.data(), [idField]: document.id } : document.data()
          ) as T[]
        ),
      error => subscriber.error(error)
    )
  );
}
